// import Select from "react-select";
// import { formatTime } from "./AddNewEmployee";
// import { Color } from "../../report/visitConstant/Color";

import { useState, useEffect } from "react";
import Select from "react-select";
import { Color } from "../../report/visitConstant/Color";
import { formatTime } from "./AddNewEmployee";
import apiHelper from "../../report/ApiHelpar/apiHelper";
import { GET_ALL_SHIFT_BY_BRANCH_ID } from "../../report/visitConstant/ApiConstant"; // Update import path



// const ShiftSelector = ({
//   slectedValue,
//   handleInputChange,
//   shiftItems,
//   inputName,
//   isDisabled = false,
// }) => {
//   const options = shiftItems.map((shift) => ({
//     value: shift.id,
//     label: shift.name,
//     startTime: formatTime(shift.startTime), // Add extra data
//     endTime: formatTime(shift.endTime),
//     totalHr: shift.totalHours,
//   }));



//   return (
//     <div className="col-8 mt-2">
//       <label htmlFor={inputName} className="col-form-label">
//         Shift
//       </label>

//       <Select
//         options={options}
//         // value={options.find((option) => option.value === slectedValue)}
//         value={
//           slectedValue
//             ? options.find((option) => option.value === slectedValue)
//             : null
//         }
//         onFocus={() =>
//           handleInputChange({ target: { name: inputName, value: "" } })
//         }
//         isClearable={true}
//         isDisabled={isDisabled}
//         onChange={(selectedOption) =>
//           handleInputChange({
//             target: {
//               name: inputName,
//               value: selectedOption ? selectedOption.value : "",
//             },
//           })
//         }
//         className="basic-select"
//         classNamePrefix="select"
//         placeholder="Select Shift"
//         getOptionLabel={(e) => (
//           <div>
//             {/* <strong style={{ fontSize: 14 }}>{e.label}</strong>{" "} */}
//             {/* Shift Name */}
//             <div style={{ fontSize: "small" }}>
//               <span className=" fw-normal" style={{ fontSize: 14 }}>
//                 {e.label}
//               </span>{" "}
//               ( {e.startTime} - {e.endTime}, {e.totalHr} hrs )
//               {/* Start Time and End Time */}
//             </div>
//           </div>
//         )}
//         styles={{
//           control: (provided, state) => ({
//             ...provided,
//             backgroundColor: isDisabled ? "#e9ecef" : "white", // Light grey when disabled

//             cursor: isDisabled ? "not-allowed" : "default", // Pointer indication
//             // borderColor: state.isFocused ? Color.lightPrimary : "#ced4da",

//             boxShadow: state.isFocused
//               ? "0 0 0 0.2rem rgba(130, 80, 255, 0.2)"
//               : null,
//           }),
//           option: (provided, state) => ({
//             ...provided,
//             backgroundColor: state.isSelected
//               ? Color.primary // Selected option background
//               : state.isFocused
//               ? Color.lightPrimary // Focused option background
//               : "white",
//             color: state.isSelected ? "white" : "black", // Text color
//             cursor: "pointer",
//           }),
//           singleValue: (provided) => ({
//             ...provided,
//             color: "black", // Disabled text color
//           }),
//           menu: (provided) => ({
//             ...provided,
//             maxHeight: "180px", // Set the maximum height for the menu
//             overflow: "hidden", // Ensures the scroll works within the defined height
//           }),
//           menuList: (provided) => ({
//             ...provided,
//             maxHeight: "180px", // Height of the scrollable container
//             overflowY: "auto", // Enables vertical scrolling
//           }),
//         }}
//       />
//     </div>
//   );
// };

// export default ShiftSelector;


const ShiftSelector = ({
  selectedValue,
  handleInputChange,
  inputName,
  isDisabled = false,
  branchId,
  FilterID // Department ID to filter shifts by
}) => {
  const [allShifts, setAllShifts] = useState([]); // Store all shifts
  const [filteredShifts, setFilteredShifts] = useState([]); // Store filtered shifts
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);



  // Fetch all shifts when branchId changes
  useEffect(() => {
    const fetchShifts = async () => {
      if (!branchId) {
        setAllShifts([]);
        setFilteredShifts([]);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const res = await apiHelper(GET_ALL_SHIFT_BY_BRANCH_ID, { branchId });
        const responseData = res?.respData?.respMsg;
       
        if (Array.isArray(responseData)) {
          setAllShifts(responseData);
          
          // Apply initial filtering if FilterID exists
          if (FilterID) {
            const shiftsForDepartment = responseData.filter(
              shift => shift?.departmentId?.id == FilterID
            );
            setFilteredShifts(shiftsForDepartment);
          } else {
            setFilteredShifts(responseData);
          }
        } else {
          setAllShifts([]);
          setFilteredShifts([]);
          console.warn("Unexpected API response format");
        }
      } catch (err) {
        console.error("Error fetching shifts:", err);
        setError(err);
        setAllShifts([]);
        setFilteredShifts([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchShifts();
  }, [branchId]);

  // Filter shifts when FilterID changes or when allShifts changes
  useEffect(() => {
    if (!allShifts.length) return;
    
    if (!FilterID) {
      // If no FilterID, show all shifts
      setFilteredShifts(allShifts);
      return;
    }

    // Filter shifts by department ID
    const shiftsForDepartment = allShifts.filter(
      shift => shift?.departmentId?.id == FilterID
    );
    
    setFilteredShifts(shiftsForDepartment);
  }, [FilterID, allShifts]);

  // Create options for the Select component from filtered shifts
  const options = filteredShifts.map(shift => ({
    id: shift.id,
    label: shift.name,
    // startTime: formatTime(shift.startTime),
    // endTime: formatTime(shift.endTime),
    startTime: shift.startTime,
    endTime: shift.endTime,
    totalHr: shift.totalHours,
  }));

  // Check if there are no items after filtering
  const noFilteredItems = filteredShifts.length === 0 && !isLoading && allShifts.length > 0;

  // Determine placeholder text based on component state
  const getPlaceholderText = () => {
    if (!branchId) return "Select a branch first";
    if (isLoading) return "Loading shifts...";
    if (noFilteredItems) return "No shifts for selected department";
    return "Select Shift";
  };

  return (
    <div className="col">
      <label htmlFor={inputName} className="col-form-label">
        Shift
        {isLoading && (
          <span className="text-muted ms-2">(Loading...)</span>
        )}
      </label>

      <Select
        options={options}
        value={
          selectedValue
            ? options.find(option => option.id == selectedValue)
            : null
        }
        onFocus={() =>
          handleInputChange({ target: { name: inputName, value: "" } })
        }
        isClearable={true}
        isDisabled={isDisabled || isLoading || !branchId || noFilteredItems}
        isLoading={isLoading}
        onChange={(selectedOption) =>
          handleInputChange({
            target: {
              name: inputName,
              value: selectedOption ? {id:selectedOption?.id} : "", // Fixed the typo here
            },
          })
        }
        className="basic-select"
        classNamePrefix="select"
        placeholder={getPlaceholderText()}
        getOptionLabel={(e) => (
          <div>
            <div style={{ fontSize: "small" }}>
              <span className="fw-normal" style={{ fontSize: 14 }}>
                {e.label}
              </span>{" "}
              ({e.startTime} - {e.endTime}, {e.totalHr} hrs)
            </div>
          </div>
        )}
        styles={{
          control: (provided, state) => ({
            ...provided,
            backgroundColor: isDisabled || noFilteredItems ? "#e9ecef" : "white",
            cursor: isDisabled || noFilteredItems ? "not-allowed" : "default",
            boxShadow: state.isFocused
              ? "0 0 0 0.2rem rgba(130, 80, 255, 0.2)"
              : null,
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
              ? Color.primary
              : state.isFocused
              ? Color.lightPrimary
              : "white",
            color: state.isSelected ? "white" : "black",
            cursor: "pointer",
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "black",
          }),
          menu: (provided) => ({
            ...provided,
            maxHeight: "180px",
            overflow: "hidden",
          }),
          menuList: (provided) => ({
            ...provided,
            maxHeight: "180px",
            overflowY: "auto",
          }),
        }}
      />

      {error && (
        <div className="text-danger mt-1">
          Failed to load shifts. Please try again.
        </div>
      )}
    </div>
  );
};

export default ShiftSelector;

// const ShiftSelector = ({
//   selectedValue,
  
//   handleInputChange,
//   inputName,
//   isDisabled = false,
//   branchId,
//   FilterID // Department ID to filter shifts by
// }) => {
//   const [allShifts, setAllShifts] = useState([]); // Store all shifts
//   const [filteredShifts, setFilteredShifts] = useState([]); // Store filtered shifts
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   console.log(FilterID ,inputName ,selectedValue ,"----------->>>>")

//   // Fetch all shifts when branchId changes
//   useEffect(() => {
//     const fetchShifts = async () => {
//       if (!branchId) {
//         setAllShifts([]);
//         setFilteredShifts([]);
//         return;
//       }

//       setIsLoading(true);
//       setError(null);

//       try {
//         const res = await apiHelper(GET_ALL_SHIFT_BY_BRANCH_ID, { branchId });
//         const responseData = res?.respData?.respMsg;
       
//         if (Array.isArray(responseData)) {
//           setAllShifts(responseData);
//           // Initial filtering will happen in the FilterID effect
//         } else {
//           setAllShifts([]);
//           setFilteredShifts([]);
//           console.warn("Unexpected API response format");
//         }
//       } catch (err) {
//         console.error("Error fetching shifts:", err);
//         setError(err);
//         setAllShifts([]);
//         setFilteredShifts([]);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchShifts();
//   }, [branchId]);

//   // Filter shifts when FilterID changes or when allShifts changes
//   useEffect(() => {
//     if (!FilterID) {
//       // If no FilterID, show all shifts
//      // setFilteredShifts(allShifts);
//       return;
//     }

//     // Filter shifts by department ID
//     const shiftsForDepartment = allShifts.filter(
//       shift => shift?.departmentId?.id == FilterID
//     );

  
    
//     setFilteredShifts(shiftsForDepartment || []);
//   }, [FilterID]);

//   // Create options for the Select component from filtered shifts
//   const options = filteredShifts.map(shift => ({
//     id : shift.id,
//     label: shift.name,
//     startTime: formatTime(shift.startTime),
//     endTime: formatTime(shift.endTime),
//     totalHr: shift.totalHours,
//   }));

//   // Check if there are no items after filtering
//   const noFilteredItems =  filteredShifts.length === 0 && !isLoading && allShifts.length > 0;

//   // Determine placeholder text based on component state
//   const getPlaceholderText = () => {
//     if (!branchId) return "Select a branch first";
//     if (isLoading) return "Loading shifts...";
//     if (noFilteredItems) return "No shifts for selected department";
//     return "Select Shift";
//   };


//   console.log("options--------->>>>>" ,options)
//   return (
//     <div className="col">
//       <label htmlFor={inputName} className="col-form-label">
//         Shift
//         {isLoading && (
//           <span className="text-muted ms-2">(Loading...)</span>
//         )}
//       </label>

//       <Select
//         options={options}
//         value={
//           selectedValue
//             ? options.find(option => option.id == selectedValue)
//             : null
//         }
//         onFocus={() =>
//           handleInputChange({ target: { name: inputName, value: "" } })
//         }
//         isClearable={true}
//         isDisabled={isDisabled || isLoading || !branchId || noFilteredItems}
//         isLoading={isLoading}
//         onChange={(selectedOption) =>
//           handleInputChange({
//             target: {
//               name: inputName,
//               value: selectedOption ? {di: selectedOption.id} : "",
//             },
//           })
//         }
//         className="basic-select"
//         classNamePrefix="select"
//         placeholder={getPlaceholderText()}
//         getOptionLabel={(e) => (
//           <div>
//             <div style={{ fontSize: "small" }}>
//               <span className="fw-normal" style={{ fontSize: 14 }}>
//                 {e.label}
//               </span>{" "}
//               ({e.startTime} - {e.endTime}, {e.totalHr} hrs)
//             </div>
//           </div>
//         )}
//         styles={{
//           control: (provided, state) => ({
//             ...provided,
//             backgroundColor: isDisabled || noFilteredItems ? "#e9ecef" : "white",
//             cursor: isDisabled || noFilteredItems ? "not-allowed" : "default",
//             boxShadow: state.isFocused
//               ? "0 0 0 0.2rem rgba(130, 80, 255, 0.2)"
//               : null,
//           }),
//           option: (provided, state) => ({
//             ...provided,
//             backgroundColor: state.isSelected
//               ? Color.primary
//               : state.isFocused
//               ? Color.lightPrimary
//               : "white",
//             color: state.isSelected ? "white" : "black",
//             cursor: "pointer",
//           }),
//           singleValue: (provided) => ({
//             ...provided,
//             color: "black",
//           }),
//           menu: (provided) => ({
//             ...provided,
//             maxHeight: "180px",
//             overflow: "hidden",
//           }),
//           menuList: (provided) => ({
//             ...provided,
//             maxHeight: "180px",
//             overflowY: "auto",
//           }),
//         }}
//       />

//       {error && (
//         <div className="text-danger mt-1">
//           Failed to load shifts. Please try again.
//         </div>
//       )}
      
//       {/* {noFilteredItems && !error && (
//         <div className="text-muted mt-1">
//           No shifts available for the selected department.
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default ShiftSelector;